<template>
  <div>
    <div v-if="eventMainCategory" class="modal__event-category">
      <div v-if="checkHasTranslation(eventCategoryTranslationKey)">
        <translated-text-component :translation="eventCategoryTranslationKey" />
      </div>
      <div v-if="modalData.category && !checkHasTranslation(modalData.category.event_code)">
        <translated-text-component :translation="`EVENT_CATEGORY_NAME_${modalData.category.event_code}`" />
      </div>
    </div>
    <div
      v-if="modalData && modalData.description"
      class="modal__description"
      v-html="modalData.description"
    ></div>

    <div v-if="modalData && modalData.subcategory" class="modal__event-subcategory">
      <strong>Kategoria: </strong>
      <span>{{modalData.subcategory.name}}</span>
    </div>
  </div>
</template>

<script lang="ts">
import {
  computed,
  defineComponent, onMounted, Ref, ref, watch,
} from 'vue';
import ModalTemplateService from '@/services/ModalTemplateService';
import store from '@/store/index';
import { IModalData } from '@/services/layers/IModalData';

const TemplateModalEvent: object = defineComponent({
  props: {
    templateData: {
      type: Object,
      required: true,
    },
  },
  name: 'TemplateModalEvent',
  setup(props) {
    const modalData: Ref<IModalData|null> = ref(null);
    const eventMainCategory: Ref<string> = ref('');
    const eventCategoryTranslationKey: Ref<string> = ref('');

    const checkHasTranslation = (translationKey: string) => {
      const { translations } = store.state;
      const allTranslationsKeys = Object.keys(translations);

      if (allTranslationsKeys.includes(translationKey)) {
        return true;
      }

      return false;
    };

    onMounted(() => {
      const { metaData } = props.templateData;
      modalData.value = metaData;
      eventMainCategory.value = metaData.category.name;
      eventCategoryTranslationKey.value = `EVENT_CATEGORY_NAME_${metaData.category.eventCode}`;
    });

    return {
      modalData,
      eventMainCategory,
      eventCategoryTranslationKey,
      checkHasTranslation,
    };
  },
});
export default TemplateModalEvent;
</script>

<style lang="scss">
  .modal__event {
    &-category {
      text-align: center;
      font-size: rem(16px);
      font-weight: 700;
      margin-bottom: rem(14px);
    }

    &-subcategory {
      text-align: center;
      padding-top: 10px;
    }
  }
</style>
